import React, { useState } from 'react';
import { Form, Card, Button, Modal, Alert, Row, Col } from 'react-bootstrap';
import { FaSearch } from 'react-icons/fa';

const AddLibraryBookRequestForm = () => {
  const [formData, setFormData] = useState({
    bookName: '',
    description: '',
    author: '',
    publication: ''
  });

  const [errors, setErrors] = useState({});
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [showErrorModal, setShowErrorModal] = useState(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const validateForm = () => {
    let formErrors = {};
    Object.keys(formData).forEach((field) => {
      if (!formData[field]) {
        formErrors[field] = `${field.replace(/([A-Z])/g, ' $1')} is required`;
      }
    });
    setErrors(formErrors);
    return Object.keys(formErrors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validateForm()) {
      setTimeout(() => {
        const isSuccess = Math.random() > 0.5;
        if (isSuccess) {
          setShowSuccessModal(true);
        } else {
          setShowErrorModal(true);
        }
      }, 1000);
    }
  };

  return (
    <Card
      className="shadow-sm rounded-lg mx-auto p-5 d-flex flex-column justify-content-between"
      style={{ maxWidth: '700px', width: '100%', height: '550px' }}
    >

      <div>
        <Form onSubmit={handleSubmit}>
          <Form.Group controlId="bookName" className="mb-4">
            <Form.Label>Book Name</Form.Label>
            <Form.Control
              type="text"
              name="bookName"
              value={formData.bookName}
              onChange={handleInputChange}
              isInvalid={!!errors.bookName}
              placeholder="Enter book name"
            />
            <Form.Control.Feedback type="invalid">
              {errors.bookName}
            </Form.Control.Feedback>
          </Form.Group>

          <Form.Group controlId="description" className="mb-4">
            <Form.Label>Description</Form.Label>
            <Form.Control
              as="textarea"
              name="description"
              rows={3}
              value={formData.description}
              onChange={handleInputChange}
              isInvalid={!!errors.description}
              placeholder="Enter description"
            />
            <Form.Control.Feedback type="invalid">
              {errors.description}
            </Form.Control.Feedback>
          </Form.Group>

          <Form.Group controlId="author" className="mb-4">
            <Form.Label>Author</Form.Label>
            <Row>
              <Col xs={11}>
                <Form.Control
                  as="select"
                  name="author"
                  value={formData.author}
                  onChange={handleInputChange}
                  isInvalid={!!errors.author}
                >
                  <option value="">Select Author</option>
                  <option value="Author 1">Author 1</option>
                  <option value="Author 2">Author 2</option>
                  <option value="Author 3">Author 3</option>
                </Form.Control>
                <Form.Control.Feedback type="invalid">
                  {errors.author}
                </Form.Control.Feedback>
              </Col>
              <Col xs={1} className="d-flex align-items-center">
                <FaSearch style={{ cursor: 'pointer' }} />
              </Col>
            </Row>
          </Form.Group>

          <Form.Group controlId="publication" className="mb-4">
            <Form.Label>Publication</Form.Label>
            <Row>
              <Col xs={11}>
                <Form.Control
                  as="select"
                  name="publication"
                  value={formData.publication}
                  onChange={handleInputChange}
                  isInvalid={!!errors.publication}
                >
                  <option value="">Select Publication</option>
                  <option value="Publication 1">Publication 1</option>
                  <option value="Publication 2">Publication 2</option>
                  <option value="Publication 3">Publication 3</option>
                </Form.Control>
                <Form.Control.Feedback type="invalid">
                  {errors.publication}
                </Form.Control.Feedback>
              </Col>
              <Col xs={1} className="d-flex align-items-center">
                <FaSearch style={{ cursor: 'pointer' }} />
              </Col>
            </Row>
          </Form.Group>
        </Form>
      </div>

      <div className="d-flex justify-content-between mt-3">
        <Button variant="primary" type="submit" onClick={handleSubmit}>
          Submit
        </Button>
        <Button variant="secondary" type="button">
          Cancel
        </Button>
      </div>

      <Modal show={showSuccessModal} onHide={() => setShowSuccessModal(false)} centered>
        <Modal.Body>
          <Alert variant="success">Request submitted successfully!</Alert>
        </Modal.Body>
        <Button variant="secondary" onClick={() => setShowSuccessModal(false)}>
          Close
        </Button>
      </Modal>

      <Modal show={showErrorModal} onHide={() => setShowErrorModal(false)} centered>
        <Modal.Body>
          <Alert variant="danger">Failed to submit request. Please try again.</Alert>
        </Modal.Body>
        <Button variant="secondary" onClick={() => setShowErrorModal(false)}>
          Close
        </Button>
      </Modal>
    </Card>
  );
};

export default AddLibraryBookRequestForm;
